import { render, staticRenderFns } from "./AddInvoiceDetail.vue?vue&type=template&id=5b1610b8&scoped=true&"
import script from "./AddInvoiceDetail.vue?vue&type=script&lang=js&"
export * from "./AddInvoiceDetail.vue?vue&type=script&lang=js&"
import style0 from "./AddInvoiceDetail.vue?vue&type=style&index=0&id=5b1610b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1610b8",
  null
  
)

export default component.exports